const TIME_INTERVAL: number = 15
const COUNT_DAYS_FOR_DELIVERY: number = 31
const TIME_COOKING: number = 30

export {TIME_INTERVAL, COUNT_DAYS_FOR_DELIVERY, TIME_COOKING}
